'use client';

import React, { memo } from 'react';
import Counter from '../Counter';
import { Box, Button } from '@chakra-ui/react';
import styles from './styles.module.css';

interface IProps {
  quantity: number;
  isOrdered: boolean;
  onClick: () => void;
  setQuantity: (e: number) => void;
  onRemove: () => void;
  children: React.ReactNode;
  isDisabled?: boolean;
}

function AddToCart({
  onClick,
  quantity,
  setQuantity,
  onRemove,
  isOrdered,
  children,
  isDisabled = false,
}: IProps) {
  const onIncrease = () => {
    setQuantity(quantity + 1);
  };
  const onDecrease = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    } else {
      onRemove();
    }
  };

  let onClickCardHandler = () => {
    onClick();
  };

  return (
    <Box w='full' className={styles.svg}>
      {isOrdered ? (
        <Counter
          variable={quantity}
          height={{ base: 10, lg: 12 }}
          onIncrease={onIncrease}
          onDecrease={onDecrease}
          bg={'product_button'}
        />
      ) : (
        <Button
          w={'full'}
          rounded={12}
          variant='subtle'
          display={'flex'}
          height={{ lg: 12 }}
          justifyContent={'center'}
          onClick={onClickCardHandler}
          size={{ base: 'md', lg: 'lg' }}
          bg='product_button'
          color='product_button.text'
          _hover={{
            bgColor: 'product_button.hover',
          }}
          disabled={isDisabled}
        >
          {children}
        </Button>
      )}
    </Box>
  );
}

export default memo(AddToCart);
